import { useContext, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { Input, Select, Checkbox } from '../../../components/ModalInputs'
import { StudentsContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { getLibraryUniversities, getLibrarySpecialities } from '../../../actions/library'

// Результат ВВК: 1=Годен, 0=Не годен
const vvkResults = [
  { name: '', value: '' },
  { name: 'Годен', value: 1 },
  { name: 'Не годен', value: 0 },
]

// Результат ФИЗО: 1=Прошёл, 0=Не прошёл
const fizoResults = [
  { name: '', value: '' },
  { name: 'Прошёл', value: 1 },
  { name: 'Не прошёл', value: 0 },
]

// Общий результат профотбора: 1=Прошёл, 0=Не прошёл
const profotborResults = [
  { name: '', value: '' },
  { name: 'Прошёл', value: 1 },
  { name: 'Не прошёл', value: 0 },
]

export default function ProfessionalSelection() {
  const dispatch = useDispatch()
  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)
  const { universities, specialities } = useSelector(state => state.library)

  const { values, setFieldValue, setValues } = allForms

  const { profotbor } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const handleProfChange = (e) => {
    const { name, value, type, checked } = e.target
    let parsed = type === 'checkbox' ? checked : value
    if (type === 'select-one' && value !== '') parsed = Number(value)
    setFieldValue(`profotbor.${name}`, parsed)
  }

  const renderOptions = ({ name, value }) => (
    <option key={value} value={value}>{name}</option>
  )

  useEffect(() => {
    if (!universities?.length) dispatch(getLibraryUniversities())
  }, []) // eslint-disable-line

  useEffect(() => {
    const universityId = (values.profotbor || {}).university
    if (universityId) dispatch(getLibrarySpecialities(universityId))
  }, [(values.profotbor || {}).university]) // eslint-disable-line

  useEffect(() => {
    const dataJson = JSON.stringify(profotbor)
    if (!addMode && profotbor && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        profotbor: { ...profotbor }
      }))
      if (updateInitialValues) {
        updateInitialValues('profotbor', profotbor)
      }
    }
  }, [profotbor, addMode, setValues, updateInitialValues])

  return (
    <div className={styles.tabWrapper}>
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Профотбор</h3>
        <div className={styles.inputsRow}>
          <Checkbox
            label='Собирается поступать в ВУЗ МО РФ'
            name='sobiraetsavvuz'
            checked={(values.profotbor || {}).sobiraetsavvuz || false}
            onChange={handleProfChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Select
            label='ВУЗ'
            style={{ width: '100%' }}
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='university'
            value={(values.profotbor || {}).university || ''}
            onChange={handleProfChange}
          >
            <option value=''>—</option>
            {(universities || []).map(u => (
              <option key={u.id || u.xp_key} value={u.id || u.xp_key}>{u.name}</option>
            ))}
          </Select>
        </div>
        <div className={styles.inputsRow}>
          <Select
            label='Специальность'
            style={{ width: '100%' }}
            disabled={!(values.profotbor || {}).sobiraetsavvuz || !(values.profotbor || {}).university}
            name='speciality'
            value={(values.profotbor || {}).speciality || ''}
            onChange={handleProfChange}
          >
            <option value=''>—</option>
            {(specialities || []).map(s => (
              <option key={s.id || s.xp_key} value={s.id || s.xp_key}>{s.name}</option>
            ))}
          </Select>
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>ВВК</h3>
        <div className={styles.inputsRow}>
          <Input
            label='Дата ВВК'
            type='date'
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='data_profobora'
            value={(values.profotbor || {}).data_profobora || ''}
            onChange={handleProfChange}
            style={{ width: '150px' }}
          />
          <Select
            label='Результат ВВК'
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='prf_result_vvk'
            value={(values.profotbor || {}).prf_result_vvk ?? ''}
            onChange={handleProfChange}
            style={{ width: '150px' }}
          >
            {vvkResults.map(renderOptions)}
          </Select>
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>ФИЗО</h3>
        <div className={styles.inputsRow}>
          <Select
            label='Результат ФИЗО'
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='prf_result_fizo'
            value={(values.profotbor || {}).prf_result_fizo ?? ''}
            onChange={handleProfChange}
            style={{ width: '150px' }}
          >
            {fizoResults.map(renderOptions)}
          </Select>
          <Input
            label='Оценка ФИЗО'
            type='number'
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='prf_fizo_grade'
            value={(values.profotbor || {}).prf_fizo_grade || ''}
            onChange={handleProfChange}
            style={{ width: '100px' }}
          />
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Итоги профотбора</h3>
        <div className={styles.inputsRow}>
          <Select
            label='Общий результат'
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='prf_result'
            value={(values.profotbor || {}).prf_result ?? ''}
            onChange={handleProfChange}
            style={{ width: '150px' }}
          >
            {profotborResults.map(renderOptions)}
          </Select>
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Личное дело сформировано'
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='lichnoe_delo'
            value={(values.profotbor || {}).lichnoe_delo || ''}
            onChange={handleProfChange}
            style={{ width: '200px' }}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Отправлено в ВУЗ'
            type='date'
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='prf_send_dt'
            value={(values.profotbor || {}).prf_send_dt || ''}
            onChange={handleProfChange}
            style={{ width: '150px' }}
          />
          <Input
            label='Получено ВУЗом'
            type='date'
            disabled={!(values.profotbor || {}).sobiraetsavvuz}
            name='prf_receive_dt'
            value={(values.profotbor || {}).prf_receive_dt || ''}
            onChange={handleProfChange}
            style={{ width: '150px' }}
          />
        </div>
      </div>
    </div>
  )
}
